export function getLockName<T extends {name?: string; nickname?: string}>(lock: T) {
    return lock.nickname || lock.name || "";
}
